import * as XLSX from "xlsx";
import { DETECTION_ORDER, TGE, findCarrier } from "./carriers";

export const AUTO = "AUTO";

export function detectCarrierFromWorkbook(workbook) {
  const detected = DETECTION_ORDER.find((carrier) => carrier.detect(workbook));
  return detected ? detected.id : "Unknown";
}

export async function processCarrierWorkbook(file, overrideCarrier = AUTO) {
  const buffer = await file.arrayBuffer();
  const workbook = XLSX.read(buffer, {
    type: "array",
    cellDates: true,
  });

  const detectedCarrier = detectCarrierFromWorkbook(workbook);
  const carrierId = overrideCarrier === AUTO ? detectedCarrier : overrideCarrier;
  const carrier = findCarrier(carrierId);

  if (!carrier) {
    throw new Error(`Carrier for file "${file.name}" could not be detected.`);
  }

  const { records, sheetSummaries } = carrier.parse(workbook, file);

  return {
    fileName: file.name,
    carrier: carrier.id,
    detectedCarrier,
    records,
    sheetSummaries,
  };
}

export async function processTgeWorkbook(file) {
  return processCarrierWorkbook(file, TGE);
}
